import { string, object } from 'yup';

export const validationSchema = object().shape({
  type: string().nullable().required('Template type is required'),
  title: string().nullable().required('Letter template name is required'),
});
